export const SKILL_LEVELS = [
  "Unranked",
  "Role Player",
  "Baller",
  "Elite",
];

// map any old labels to the canonical values
export function normalizeSkillLevel(v) {
  if (!v) return "Unranked";
  const s = String(v).toLowerCase().trim();
  const map = {
    beginner: "Unranked",
    "role player": "Role Player",
    "roll player": "Role Player",
    intermediate: "Role Player",
    advanced: "Baller",
    baller: "Baller",
    pro: "Elite",
    elite: "Elite",
    unranked: "Unranked",
  };
  return map[s] || "Unranked";
}
